export var ADAPTER_NAMES;
(function (ADAPTER_NAMES) {
    ADAPTER_NAMES["GOODBOT_FLOW"] = "goodbot-flow";
    ADAPTER_NAMES["ADASTRA"] = "adastra";
    ADAPTER_NAMES["MISSING"] = "missing";
    ADAPTER_NAMES["VA2"] = "va2";
    ADAPTER_NAMES["INTEGRATION"] = "integration";
})(ADAPTER_NAMES || (ADAPTER_NAMES = {}));
